import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Link } from '@material-ui/core';
import { Link as BaseLink } from 'react-router-dom';

import Breadcrumbs from '../../../components/Breadcrumbs';
import { ROUTES } from '../../../core/router/routes';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import PageView from '../../../components/PageView';
import { PANEL_VIEW } from '../../../components/SearchPanel/enum/searchPanelProps';
import ResultsProgress from '../../../components/progress/ResultsProgress';
import useResultsProgressContext from '../../../components/progress/ResultsProgress/context/ResultsContext';
import { useGetArticlesSearchQuery } from '../api/articleApi';
import * as commonSelectors from '../../../shared/redux/commonSelectors';
import { setBreadcrumbs } from '../../../shared/redux/commonSlice';

import './articleResults.scss';

const ArticleResults: React.FC = () => {
  const { t } = useTranslation();
  const phrase = useSelector(commonSelectors.phrase);
  const mainProgress = useMainProgressContext();
  const resultsProgress = useResultsProgressContext();
  const dispatch = useDispatch();
  const {
    data: articlesSearch,
    isSuccess,
    isLoading,
  } = useGetArticlesSearchQuery({
    phrase: phrase,
  });

  useEffect(() => {
    dispatch(setBreadcrumbs([]));

    resultsProgress.show();
    mainProgress.hide();
  }, []);

  useEffect(() => {
    if (isSuccess) {
      resultsProgress.hide();
    }

    if (isLoading) {
      resultsProgress.show();
    }
  }, [isSuccess, isLoading]);

  return (
    <>
      <PageView view={PANEL_VIEW.MINIMUM} showMostSearched={false} className="ArticleResults-PageView">
        <Breadcrumbs title={t('article.search_results')} />
        <h2>
          {t('search_panel.search')}: <span>{phrase}</span>
        </h2>
        <ResultsProgress />
        <section className="results">
          {isSuccess && articlesSearch.length ? (
            articlesSearch.map((article) => (
              <div key={article.id} className="article">
                <div className="title">
                  <Link
                    color="inherit"
                    to={ROUTES.ARTICLE.SHOW.replace(':id', article.id as unknown as string)}
                    component={BaseLink}
                  >
                    {article.title}
                  </Link>
                </div>
                <p className="breadcrumbs">{article.breadcrumbs}</p>
                <div className="content" dangerouslySetInnerHTML={{ __html: article.contentTeaser }}></div>
                <div className="more">
                  <Link
                    color="inherit"
                    to={ROUTES.ARTICLE.SHOW.replace(':id', article.id as unknown as string)}
                    component={BaseLink}
                  >
                    {t('article.more')}
                  </Link>
                </div>
                <Divider />
              </div>
            ))
          ) : (
            <div>
              <h1>{t('article.no_articles_found_for_the_search_term')}</h1>
            </div>
          )}
        </section>
      </PageView>
    </>
  );
};

export default ArticleResults;
